// extracted by mini-css-extract-plugin
export default {"tooltip-content":"styles_tooltip-content__XwWJR","tooltip-content-wrapper":"styles_tooltip-content-wrapper__7QiuE","tooltip-ellipsis":"styles_tooltip-ellipsis__SorF0"};